module.exports = {"652723100":"博格达尔镇","652723101":"哈日布呼镇","652723102":"安格里格镇","652723201":"查干屯格乡","652723202":"扎勒木特乡","652723203":"塔秀乡","652723400":"呼和托哈种畜场","652723401":"昆得仑牧场","652723502":"兵团八十七团","652723503":"兵团八十八团"}


//////////////////
// WEBPACK FOOTER
// ./src/town/652723.json
// module id = 3081
// module chunks = 0